"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function useRafLoop(callback) {
    const raf = react_1.default.useRef(null);
    const [isActive, setIsActive] = react_1.default.useState(true);
    const loopStep = react_1.default.useCallback(() => {
        callback();
        raf.current = requestAnimationFrame(loopStep);
    }, [callback]);
    const stop = react_1.default.useCallback(() => {
        setIsActive(false);
    }, []);
    const start = react_1.default.useCallback(() => {
        setIsActive(true);
    }, []);
    const clear = react_1.default.useCallback(() => {
        if (raf.current) {
            cancelAnimationFrame(raf.current);
        }
    }, []);
    react_1.default.useEffect(() => clear, [clear]);
    react_1.default.useEffect(() => {
        clear();
        if (isActive) {
            raf.current = requestAnimationFrame(loopStep);
        }
        return clear;
    }, [isActive, callback, loopStep, clear]);
    return [start, stop, isActive];
}
exports.default = useRafLoop;
